export default __webpack_public_path__ + "static/media/star.a0fca150.svg";